import { Push } from './push-vue'

const PUSH_CONFIG_KEY = 'pushConfig'

// 内存缓存，避免每次读 sessionStorage 都 JSON.parse
let pushConfig = null

/** 推送配置（登录后由 setPushConfig 写入；没拿到返回 null） */
export function getPushConfig() {
  if (!pushConfig) {
    try {
      pushConfig = JSON.parse(sessionStorage.getItem(PUSH_CONFIG_KEY)) || null
    } catch (e) {
      // sessionStorage 里的值被写坏时不能往外抛：调用方在 router 守卫里
      pushConfig = null
    }
  }
  return pushConfig
}

/**
 *
 * @param {{ws_url: string, app_key: string, auth_url: string, channel: string, chat_uid: string}} data
 * @returns {object|null} 写入成功返回配置，字段不全返回 null
 */
export function setPushConfig(data) {
  if (!data || !data.ws_url || !data.app_key) {
    console.warn('🚀推送配置不完整，实时消息推送已降级', data)
    // 清掉上一次的配置和连接：否则换账号后守卫会读到旧账号的 channel / chatUid
    disconnectPush()
    return null
  }
  pushConfig = {
    url: data.ws_url,
    app_key: data.app_key,
    // 鉴权地址带上 token：push-vue 的鉴权请求是裸 XHR，不带 cookie 也不带 header
    authUrl: data.auth_url,
    // 订阅频道（后端下发的 channel）和聊天身份 id 一起存这里：
    // 刷新后 router 守卫同步调 startListening，只有 sessionStorage 兜得住
    channel: data.channel || '',
    chatUid: data.chat_uid || ''
  }
  sessionStorage.setItem(PUSH_CONFIG_KEY, JSON.stringify(pushConfig))
  return pushConfig
}

// 全局唯一的 Push 实例
let client = null

// 初始化 Push 实例（幂等）
export function initPush() {
  // 没拿到配置时整个推送降级（页面仍可用，只是收不到实时消息）
  const config = getPushConfig()
  if (!config) {
    console.warn('🚀未拿到推送配置（/admin/im/wstoken），实时消息推送已降级')
    return null
  }
  if (client) return client
  client = new Push({
    url: config.url,
    app_key: config.app_key,
    auth: config.authUrl
  })
  return client
}

/**
 * 订阅频道并监听事件，返回取消监听的函数
 * @param {string} channel 频道名
 * @param {string} event   事件名
 * @param {Function} callback 事件回调
 * @returns {Function} 取消订阅（channel.off）；未配置推送时返回空函数
 */
export function webmanOnMessage(channel, event, callback) {
  const push = initPush()
  if (!push) return () => {}
  console.log('🚀事件名：', event)
  const ch = push.subscribe(channel)
  console.log('🚀私有频道订阅成功,频道名', ch.channelName)
  ch.on(event, callback)
  return () => ch.off(event, callback)
}

/** 登出时断开连接，并清掉缓存的推送配置（换账号后必须重新调 /admin/im/wstoken） */
export function disconnectPush() {
  if (client) {
    client.disconnect()
    client = null
  }
  pushConfig = null
  sessionStorage.removeItem(PUSH_CONFIG_KEY)
}
